import type { VersionedJson } from '@builder4/shared/migrations/types';

export default function toV1<T extends VersionedJson>(data: T): T {
  // Return as-is - the runner will set version: 1
  return data;
}
